import { installEarlyConsentDefaults } from '../cookie-banner/gating';
import bootstrap from '../cookie-banner/index';

// Push Consent Mode v2 defaults as early as possible (before DOMContentLoaded)
// so GTM/GA see denied storage before tags fire.
installEarlyConsentDefaults();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
